import { DateRange } from 'react-day-picker';

import { getFormattedDate } from './getFormattedDate';

export const getInputLabel = (fallbackLabel: string, range?: DateRange) => {
    if (!range?.to && range?.from) {
        return `${getFormattedDate(range?.from)} - ${fallbackLabel}`;
    } else if (!range?.from && range?.to) {
        return `${fallbackLabel} - ${getFormattedDate(range?.to)}`;
    } else if (range?.from && range?.to) {
        return `${getFormattedDate(range?.from)} - ${getFormattedDate(
            range?.to
        )}`;
    }
    return '';
};
